var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "article",
    {
      class: [
        _vm.labelClass,
        "dc-post-grid-card default-card post-summary default"
      ],
      attrs: { id: _vm.id },
      on: {
        click: function($event) {
          $event.stopPropagation()
          $event.preventDefault()
          return _vm.goToPost()
        }
      }
    },
    [
      _c("div", { staticClass: "dc-post-grid-card-inner post-summary-inner" }, [
        _c(
          "div",
          {
            class: [
              "image-wrapper",
              {
                "no-image": !_vm.image
              }
            ]
          },
          [
            _vm.image
              ? _c("img", {
                  attrs: {
                    src: _vm.image.src,
                    srcset: _vm.image.srcset,
                    alt: _vm.image.alt
                  }
                })
              : _vm._e()
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { ref: "cardContentWrapper", staticClass: "content-wrapper" },
          [
            _c("div", {
              ref: "cardContentHoverOverlay",
              staticClass: "content-hover-overlay"
            }),
            _vm._v(" "),
            _vm.date
              ? _c("span", { staticClass: "post-date" }, [
                  _vm._v(_vm._s(_vm.date))
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.label && typeof _vm.label.url !== "undefined"
              ? _c(
                  "a",
                  {
                    staticClass: "post-summary-category",
                    attrs: { href: _vm.label.url }
                  },
                  [_vm._v(_vm._s(_vm.label.title))]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.label && typeof _vm.label.url === "undefined"
              ? _c("span", { staticClass: "post-summary-category" }, [
                  _vm._v(_vm._s(_vm.label.title))
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.title
              ? _c("h1", { staticClass: "card-title" }, [
                  _vm._v(_vm._s(_vm.title))
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.excerpt
              ? _c("div", {
                  staticClass: "card-excerpt",
                  domProps: { innerHTML: _vm._s(_vm.excerpt) }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.url
              ? _c(
                  "a",
                  {
                    ref: "postLink",
                    staticClass: "link read-more-link",
                    attrs: { href: _vm.url }
                  },
                  [
                    _c("span", { staticClass: "screen-reader-text" }, [
                      _vm._v("Read more")
                    ])
                  ]
                )
              : _vm._e()
          ]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }